import { AxiosAdapter } from '../commons/adapters';

const http = new AxiosAdapter();

export const getReviewLinksService = async () => {
  try {
    return await http.get('/v1/ratings/review-links');
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getReviewLinksService ', error);
  }
};

export const createReviewLinkService = async (data: any) => {
  try {
    return await http.post('/v1/ratings/review-links', data, () => {});
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createReviewLinkService ', error);
  }
};

export const updateReviewLinkService = async (id: string, data: any) => {
  try {
    return await http.put(`/v1/ratings/review-links/${id}`, data);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('updateReviewLinkService ', error);
  }
};

export const deleteReviewLinkService = async (id: string) => {
  try {
    return await http.delete(`/v1/ratings/review-links/${id}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('deleteReviewLinkService ', error);
  }
};
